import React, { useContext } from "react";
import { Container, InputsArea } from "./styles";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { setUserAccess } from "../../api/autenticoAPI";
import { CustomAlert } from "../CustomAlert/CustomAlert";
import { TeacherAllocationsForm } from "./TeacherAllocationsForm";

// Todos os níveis de acesso (para administradores)
const itens = [
  { level: "admin", label: "ADMINISTRADOR" },
  { level: "assistant", label: "AUXILIAR" },
  { level: "caixa", label: "CAIXA" },
  { level: "coordinator", label: "COORDENADOR" },
  { level: "director", label: "DIRETOR" },
  { level: "teacher", label: "PROFESSOR" },
];

// Níveis de acesso que coordenadores podem cadastrar
const coordinatorAllowedLevels = [
  { level: "assistant", label: "AUXILIAR" },
  { level: "teacher", label: "PROFESSOR" },
];

export function UserRegistration({ teacher }) {
  const auth = useContext(AuthContext);
  const [name, setName] = useState("");
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [level, setLevel] = useState(teacher ? "teacher" : "");
  const [allocations, setAllocations] = useState([]);
  const [infoType, setInfoType] = useState("success");
  const [status, setStatus] = useState(false);
  const [infoMessage, setInfoMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const resetStates = () => {
    setName("");
    setLogin("");
    setPassword("");
    setLevel(teacher ? "teacher" : "");
    setAllocations([]);
  };

  const handleRegister = async () => {
    // Prevenir múltiplos cliques
    if (loading) {
      return;
    }

    // Validação básica
    if (!name || !login || !password || !level) {
      setStatus(true);
      setInfoType("error");
      setInfoMessage("Todos os campos são obrigatórios");
      return;
    }

    setLoading(true);
    try {
      const newUser = {
        name,
        password,
        level,
        login,
        unit: auth.user.unit,
        // Sempre incluir allocations se for professor (mesmo que vazio)
        ...(level === "teacher" ? { allocations: allocations.length > 0 ? allocations : [] } : {}),
      };
      const response = await setUserAccess(newUser);
      if (response.status) {
        setStatus(true);
        setInfoType("success");
        setInfoMessage(response.message);
        resetStates();
      } else {
        setStatus(true);
        setInfoType("error");
        setInfoMessage(response.message);
      }
    } catch (error) {
      setStatus(true);
      setInfoType("error");
      // Tratar erro de login duplicado
      if (error.response?.status === 409 || error.response?.data?.message?.includes("cadastrado") || error.response?.data?.message?.includes("já existe")) {
        setInfoMessage("Este login já está cadastrado. Por favor, escolha outro login.");
      } else {
        setInfoMessage(error.response?.data?.message || "Erro ao cadastrar usuário. Tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <Container>
      <InputsArea>
        <TextField
          value={name}
          onChange={({ target }) => setName(target.value)}
          label="Nome"
          variant="outlined"
          fullWidth
        />
        <TextField
          value={login}
          onChange={({ target }) => setLogin(target.value)}
          label="Usuário"
          variant="outlined"
          fullWidth
        />
        <TextField
          value={password}
          onChange={({ target }) => setPassword(target.value)}
          label="Senha"
          variant="outlined"
          fullWidth
        />
        <FormControl fullWidth>
          <InputLabel>Nível de Acesso</InputLabel>
          <Select
            value={level}
            label="Nível de Acesso"
            onChange={({ target }) => setLevel(target.value)}
            readOnly={teacher}
            defaultValue={teacher && "teacher"}
          >
            {!teacher && (() => {
              // Se for coordenador, mostrar apenas auxiliar e professor
              if (auth.user?.level === "coordinator") {
                return coordinatorAllowedLevels.map((item) => (
                  <MenuItem key={item.level} value={item.level}>
                    {item.label}
                  </MenuItem>
                ));
              }
              // Se for admin, mostrar todos os níveis (incluindo teacher)
              return itens.map((item) => (
                <MenuItem key={item.level} value={item.level}>
                  {item.label}
                </MenuItem>
              ));
            })()}
            {teacher && <MenuItem value={"teacher"}>PROFESSOR</MenuItem>}
          </Select>
        </FormControl>

        {/* Mostrar formulário de alocações apenas para professores */}
        {level === "teacher" && (
          <TeacherAllocationsForm
            allocations={allocations}
            onChange={setAllocations}
          />
        )}

        <Button
          variant="contained"
          fullWidth
          color="primary"
          onClick={() => handleRegister()}
          disabled={loading}
        >
          {loading ? "Cadastrando..." : "Cadastrar"}
        </Button>
      </InputsArea>
      <CustomAlert
        infoType={infoType}
        status={status}
        setStatus={setStatus}
        infoMessage={infoMessage}
      />
    </Container>
  );
}
